var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.busy,
          expression: "busy",
        },
      ],
      staticClass: "fc",
    },
    [
      _vm._m(0),
      _vm.error
        ? _c("el-alert", {
            attrs: {
              title: _vm.error,
              type: "error",
              closable: false,
              "show-icon": "",
            },
          })
        : _vm._e(),
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.changeTab },
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        [
          _vm.permissions.list
            ? _c("el-tab-pane", {
                attrs: { label: "全部文件", name: "ACTIVE" },
              })
            : _vm._e(),
          _vm.permissions.list
            ? _c("el-tab-pane", { attrs: { label: "回收站", name: "TRASH" } })
            : _vm._e(),
          _vm.permissions.organize
            ? _c("el-tab-pane", { attrs: { label: "域与组管理", name: "ORG" } })
            : _vm._e(),
          _vm.permissions.audit
            ? _c("el-tab-pane", { attrs: { label: "操作日志", name: "AUDIT" } })
            : _vm._e(),
        ],
        1
      ),
      _vm.tab === "ACTIVE" || _vm.tab === "TRASH"
        ? [
            _vm.tab === "TRASH"
              ? _c("el-alert", {
                  attrs: {
                    title:
                      "删除后30天内可恢复；归属显示删除时快照。超过期限不可恢复；彻底删除后将从回收站移除，无法找回。",
                    type: "info",
                    closable: false,
                  },
                })
              : _vm._e(),
            _c(
              "el-form",
              {
                staticClass: "filters",
                attrs: { inline: "", size: "small" },
                nativeOn: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.search.apply(null, arguments)
                  },
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "文件名" } },
                  [
                    _c("el-input", {
                      attrs: {
                        clearable: "",
                        maxlength: "200",
                        placeholder: "输入文件名模糊查询",
                      },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.search.apply(null, arguments)
                        },
                      },
                      model: {
                        value: _vm.query.keyword,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "keyword", $$v)
                        },
                        expression: "query.keyword",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "来源" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { clearable: "", placeholder: "全部来源" },
                        model: {
                          value: _vm.query.sourceType,
                          callback: function ($$v) {
                            _vm.$set(_vm.query, "sourceType", $$v)
                          },
                          expression: "query.sourceType",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "聊天文件", value: "CHAT" },
                        }),
                        _c("el-option", {
                          attrs: { label: "邮件附件", value: "MAIL" },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "类型" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { clearable: "", placeholder: "全部类型" },
                        model: {
                          value: _vm.query.category,
                          callback: function ($$v) {
                            _vm.$set(_vm.query, "category", $$v)
                          },
                          expression: "query.category",
                        },
                      },
                      _vm._l(_vm.categories, function (c) {
                        return _c("el-option", {
                          key: c[0],
                          attrs: { label: c[1], value: c[0] },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "大小(MB)" } },
                  [
                    _c("el-input-number", {
                      attrs: { min: 0, controls: false, placeholder: "最小" },
                      model: {
                        value: _vm.minMB,
                        callback: function ($$v) {
                          _vm.minMB = $$v
                        },
                        expression: "minMB",
                      },
                    }),
                    _vm._v(" — "),
                    _c("el-input-number", {
                      attrs: { min: 0, controls: false, placeholder: "最大" },
                      model: {
                        value: _vm.maxMB,
                        callback: function ($$v) {
                          _vm.maxMB = $$v
                        },
                        expression: "maxMB",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "上传日期" } },
                  [
                    _c("el-date-picker", {
                      attrs: {
                        type: "daterange",
                        "value-format": "yyyy-MM-dd",
                        "start-placeholder": "开始日期",
                        "end-placeholder": "结束日期",
                      },
                      model: {
                        value: _vm.dates,
                        callback: function ($$v) {
                          _vm.dates = $$v
                        },
                        expression: "dates",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "域" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          multiple: "",
                          clearable: "",
                          filterable: "",
                          "collapse-tags": "",
                        },
                        model: {
                          value: _vm.query.domainIds,
                          callback: function ($$v) {
                            _vm.$set(_vm.query, "domainIds", $$v)
                          },
                          expression: "query.domainIds",
                        },
                      },
                      _vm._l(_vm.org.domains, function (d) {
                        return _c("el-option", {
                          key: d.id,
                          attrs: { label: d.name, value: d.id },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "组" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          multiple: "",
                          clearable: "",
                          filterable: "",
                          "collapse-tags": "",
                        },
                        model: {
                          value: _vm.query.groupIds,
                          callback: function ($$v) {
                            _vm.$set(_vm.query, "groupIds", $$v)
                          },
                          expression: "query.groupIds",
                        },
                      },
                      _vm._l(_vm.org.groups, function (g) {
                        return _c("el-option", {
                          key: g.id,
                          attrs: { label: _vm.groupName(g), value: g.id },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.openPicker("employees")
                          },
                        },
                      },
                      [
                        _vm._v(
                          "选择发送人 (" +
                            _vm._s(_vm.query.userIds.length) +
                            ")"
                        ),
                      ]
                    ),
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.openPicker("recipients")
                          },
                        },
                      },
                      [
                        _vm._v(
                          "选择接收人 (" +
                            _vm._s(_vm.query.recipientIds.length) +
                            ")"
                        ),
                      ]
                    ),
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.openPicker("conversations")
                          },
                        },
                      },
                      [
                        _vm._v(
                          "选择单聊 / 群 (" +
                            _vm._s(_vm.query.conversationIds.length) +
                            ")"
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-checkbox",
                      {
                        model: {
                          value: _vm.query.unclassified,
                          callback: function ($$v) {
                            _vm.$set(_vm.query, "unclassified", $$v)
                          },
                          expression: "query.unclassified",
                        },
                      },
                      [_vm._v("含未分组员工")]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      { attrs: { type: "primary" }, on: { click: _vm.search } },
                      [_vm._v("查询")]
                    ),
                    _c("el-button", { on: { click: _vm.reset } }, [
                      _vm._v("重置"),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("p", { staticClass: "hint" }, [
              _vm._v(
                "域、组、发送人、聊天会话组合为“任一匹配”，再叠加文件名、类型、大小和日期。接收人筛选须同时满足，多位接收人任一匹配；群聊按可见消息的接收成员匹配。"
              ),
            ]),
            _c(
              "div",
              { staticClass: "toolbar" },
              [
                _c("span", [
                  _vm._v(
                    "共 " +
                      _vm._s(_vm.total) +
                      " 份 · 已选 " +
                      _vm._s(_vm.selected.length) +
                      " 份（当前页）"
                  ),
                ]),
                _vm.permissions.download
                  ? _c(
                      "el-button",
                      {
                        attrs: {
                          size: "small",
                          disabled: !_vm.selected.length,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.batch("download")
                          },
                        },
                      },
                      [_vm._v("批量下载")]
                    )
                  : _vm._e(),
                _vm.permissions.delete && _vm.tab === "ACTIVE"
                  ? _c(
                      "el-button",
                      {
                        attrs: {
                          size: "small",
                          type: "danger",
                          plain: "",
                          disabled: !_vm.selected.length,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.batch("delete")
                          },
                        },
                      },
                      [_vm._v("移入回收站")]
                    )
                  : _vm._e(),
                _vm.permissions.restore && _vm.tab === "TRASH"
                  ? _c(
                      "el-button",
                      {
                        attrs: {
                          size: "small",
                          disabled: !_vm.selected.length,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.batch("restore")
                          },
                        },
                      },
                      [_vm._v("恢复所选")]
                    )
                  : _vm._e(),
                _vm.permissions.delete && _vm.tab === "TRASH"
                  ? _c(
                      "el-button",
                      {
                        attrs: {
                          size: "small",
                          type: "danger",
                          plain: "",
                          disabled: !_vm.selected.length,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.batch("purge")
                          },
                        },
                      },
                      [_vm._v("彻底删除所选")]
                    )
                  : _vm._e(),
                _c(
                  "el-radio-group",
                  {
                    attrs: { size: "small" },
                    model: {
                      value: _vm.view,
                      callback: function ($$v) {
                        _vm.view = $$v
                      },
                      expression: "view",
                    },
                  },
                  [
                    _c("el-radio-button", { attrs: { label: "list" } }, [
                      _vm._v("列表"),
                    ]),
                    _c("el-radio-button", { attrs: { label: "grid" } }, [
                      _vm._v("宫格"),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm.view === "list"
              ? _c(
                  "el-table",
                  {
                    attrs: { data: _vm.rows, "row-key": "id", border: "" },
                    on: {
                      "selection-change": function ($event) {
                        _vm.selected = $event
                      },
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { type: "selection", width: "45" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "文件", "min-width": "240" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "button",
                                  {
                                    staticClass: "file-name",
                                    on: {
                                      click: function ($event) {
                                        return _vm.preview(row)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "b",
                                      {
                                        staticClass: "file-icon",
                                        style: { background: _vm.icon(row)[1] },
                                      },
                                      [_vm._v(_vm._s(_vm.icon(row)[0]))]
                                    ),
                                    _c("span", [_vm._v(_vm._s(row.fileName))]),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2548705572
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "来源 / 发送位置", "min-width": "190" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _vm._v(
                                  _vm._s(
                                    row.sourceType === "CHAT"
                                      ? "聊天文件"
                                      : "邮件附件"
                                  )
                                ),
                                _c("p", [_vm._v(_vm._s(row.contextText))]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3035641420
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "ownerName",
                        label: "发送人",
                        width: "110",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "域 / 组", "min-width": "160" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _vm._v(
                                  _vm._s(row.domainName || "未分类") +
                                    " / " +
                                    _vm._s(row.groupName || "未分组")
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        4046586105
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "大小", width: "100" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [_vm._v(_vm._s(_vm.size(row.fileSize)))]
                            },
                          },
                        ],
                        null,
                        false,
                        3532572600
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "createdAt",
                        label: "上传时间",
                        width: "165",
                      },
                    }),
                    _vm.tab === "TRASH"
                      ? _c("el-table-column", {
                          attrs: { label: "恢复期限", width: "165" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    _vm._v(
                                      _vm._s(
                                        row.canRestore
                                          ? row.recoverUntil
                                          : "已到期"
                                      )
                                    ),
                                    _c("p", [_vm._v(_vm._s(row.deleteReason))]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            819085312
                          ),
                        })
                      : _vm._e(),
                    _c("el-table-column", {
                      attrs: {
                        label: "操作",
                        width: _vm.tab === "TRASH" ? 220 : 135,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.detail(row)
                                      },
                                    },
                                  },
                                  [_vm._v("详情")]
                                ),
                                _vm.permissions.download
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "mini",
                                          type: "text",
                                          disabled: !row.canPreview,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.download(row)
                                          },
                                        },
                                      },
                                      [_vm._v("下载")]
                                    )
                                  : _vm._e(),
                                _vm.permissions.delete && _vm.tab === "TRASH"
                                  ? _c(
                                      "el-button",
                                      {
                                        staticClass: "danger-text",
                                        attrs: { size: "mini", type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.batch("purge", [row])
                                          },
                                        },
                                      },
                                      [_vm._v("彻底删除")]
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        455436175
                      ),
                    }),
                  ],
                  1
                )
              : _c(
                  "div",
                  { staticClass: "grid" },
                  _vm._l(_vm.rows, function (a) {
                    return _c(
                      "article",
                      { key: a.id, attrs: { "data-id": a.id } },
                      [
                        _c(
                          "el-checkbox",
                          {
                            attrs: {
                              value: _vm.selected.some((x) => x.id === a.id),
                            },
                            on: {
                              change: function ($event) {
                                return _vm.toggle(a, $event)
                              },
                            },
                          },
                          [_vm._v("选择")]
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "grid-file",
                            on: {
                              click: function ($event) {
                                return _vm.preview(a)
                              },
                            },
                          },
                          [
                            _c(
                              "b",
                              {
                                staticClass: "file-icon",
                                style: { background: _vm.icon(a)[1] },
                              },
                              [_vm._v(_vm._s(_vm.icon(a)[0]))]
                            ),
                            _c("strong", [_vm._v(_vm._s(a.fileName))]),
                          ]
                        ),
                        _c("p", [
                          _vm._v(
                            _vm._s(_vm.size(a.fileSize)) +
                              " · " +
                              _vm._s(a.ownerName)
                          ),
                        ]),
                        _c("p", [
                          _vm._v(
                            _vm._s(a.domainName || "未分类") +
                              " / " +
                              _vm._s(a.groupName || "未分组")
                          ),
                        ]),
                        _c("p", [_vm._v(_vm._s(a.contextText))]),
                        _c("p", [_vm._v(_vm._s(a.createdAt))]),
                        _vm.tab === "TRASH"
                          ? _c("p", [
                              _vm._v(
                                _vm._s(
                                  a.canRestore
                                    ? "恢复期限 " + a.recoverUntil
                                    : "已到期"
                                )
                              ),
                            ])
                          : _vm._e(),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.detail(a)
                              },
                            },
                          },
                          [_vm._v("详情")]
                        ),
                        _vm.permissions.download
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "text",
                                  disabled: !a.canPreview,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.download(a)
                                  },
                                },
                              },
                              [_vm._v("下载")]
                            )
                          : _vm._e(),
                        _vm.permissions.delete && _vm.tab === "TRASH"
                          ? _c(
                              "el-button",
                              {
                                staticClass: "danger-text",
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.batch("purge", [a])
                                  },
                                },
                              },
                              [_vm._v("彻底删除")]
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  }),
                  0
                ),
            !_vm.rows.length
              ? _c("el-empty", { attrs: { description: "没有符合条件的文件" } })
              : _vm._e(),
            _c("el-pagination", {
              attrs: {
                "current-page": _vm.query.pageNo,
                "page-size": _vm.query.pageSize,
                total: _vm.total,
                layout: "total,prev,pager,next",
              },
              on: {
                "update:currentPage": function ($event) {
                  return _vm.$set(_vm.query, "pageNo", $event)
                },
                "update:current-page": function ($event) {
                  return _vm.$set(_vm.query, "pageNo", $event)
                },
                "current-change": _vm.load,
              },
            }),
          ]
        : _vm._e(),
      _vm.tab === "ORG" && _vm.permissions.organize
        ? _c("organization", {
            attrs: { org: _vm.org },
            on: { changed: _vm.loadOrg },
          })
        : _vm._e(),
      _vm.tab === "AUDIT"
        ? _c(
            "el-table",
            { attrs: { data: _vm.logs } },
            [
              _c("el-table-column", {
                attrs: { prop: "createdAt", label: "时间" },
              }),
              _c("el-table-column", {
                attrs: { prop: "actorName", label: "操作人" },
              }),
              _c("el-table-column", {
                attrs: { prop: "action", label: "操作" },
              }),
              _c("el-table-column", {
                attrs: { prop: "assetId", label: "文件ID" },
              }),
              _c("el-table-column", {
                attrs: { prop: "detail", label: "详情" },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.tab === "AUDIT" && _vm.logs.length
        ? _c("el-button", { on: { click: _vm.moreLogs } }, [
            _vm._v("加载更早记录"),
          ])
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": "",
            title:
              _vm.pickerKind === "recipients"
                ? "选择接收人（最多100人）"
                : _vm.pickerKind === "employees"
                ? "选择发送人（最多100人）"
                : "选择聊天会话（最多100项）",
            visible: _vm.pickerOpen,
            width: "650px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.pickerOpen = $event
            },
            close: function ($event) {
              _vm.pickerVersion++
            },
          },
        },
        [
          _vm.pickerKind !== "conversations"
            ? _c("el-cascader", {
                ref: "departmentPicker",
                attrs: {
                  options: _vm.departmentOptions,
                  props: { checkStrictly: true, emitPath: false },
                  clearable: "",
                  filterable: "",
                  placeholder: "按组织查看员工（含下属部门）",
                },
                on: { change: _vm.departmentChanged },
                model: {
                  value: _vm.pickerDepartment,
                  callback: function ($$v) {
                    _vm.pickerDepartment = $$v
                  },
                  expression: "pickerDepartment",
                },
              })
            : _vm._e(),
          _vm.pickerKind !== "conversations" && _vm.org.groups.length
            ? _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: "按聊天文件分组筛选",
                  },
                  on: { change: _vm.pickerSearch },
                  model: {
                    value: _vm.pickerGroup,
                    callback: function ($$v) {
                      _vm.pickerGroup = $$v
                    },
                    expression: "pickerGroup",
                  },
                },
                _vm._l(_vm.org.groups, function (g) {
                  return _c("el-option", {
                    key: g.id,
                    attrs: { label: _vm.groupName(g), value: g.id },
                  })
                }),
                1
              )
            : _vm._e(),
          _c("el-input", {
            attrs: { placeholder: "输入姓名、工号或会话名称" },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.pickerSearch.apply(null, arguments)
              },
            },
            model: {
              value: _vm.pickerKeyword,
              callback: function ($$v) {
                _vm.pickerKeyword = $$v
              },
              expression: "pickerKeyword",
            },
          }),
          _c("el-button", { on: { click: _vm.pickerSearch } }, [
            _vm._v("搜索"),
          ]),
          !_vm.pickerLoading && !_vm.pickerRows.length
            ? _c("el-empty", {
                attrs: { description: "该组织或搜索条件下暂无员工/会话" },
              })
            : _vm._e(),
          _c(
            "el-checkbox-group",
            {
              model: {
                value: _vm.pickerIds,
                callback: function ($$v) {
                  _vm.pickerIds = $$v
                },
                expression: "pickerIds",
              },
            },
            _vm._l(_vm.pickerRows, function (p) {
              return _c(
                "div",
                { key: p.id, staticClass: "person" },
                [
                  _c("el-checkbox", { attrs: { label: p.id } }, [
                    _vm._v(
                      _vm._s(p.name) +
                        " " +
                        _vm._s(p.serial || "") +
                        " " +
                        _vm._s(p.type === "GROUP" ? "（聊天群）" : "") +
                        " "
                    ),
                    p.department
                      ? _c("small", [_vm._v(_vm._s(p.department))])
                      : _vm._e(),
                  ]),
                ],
                1
              )
            }),
            0
          ),
          _c(
            "el-button",
            {
              attrs: {
                disabled: _vm.pickerDone || _vm.pickerLoading,
                loading: _vm.pickerLoading,
              },
              on: { click: _vm.morePicker },
            },
            [_vm._v("加载更多")]
          ),
          _c("p", [
            _vm._v(
              "已选 " +
                _vm._s(_vm.pickerIds.length) +
                " 项；翻页与搜索保留所选项。"
            ),
          ]),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.pickerIds = []
                    },
                  },
                },
                [_vm._v("清空")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmPicker },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": "",
            title: "文件详情",
            visible: _vm.detailOpen,
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailOpen = $event
            },
          },
        },
        [
          _vm.current
            ? _c(
                "el-descriptions",
                { attrs: { column: 1, border: "" } },
                [
                  _c("el-descriptions-item", { attrs: { label: "文件" } }, [
                    _vm._v(_vm._s(_vm.current.fileName)),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "发送人" } }, [
                    _vm._v(
                      _vm._s(_vm.current.ownerName) +
                        " (" +
                        _vm._s(_vm.current.ownerId) +
                        ")"
                    ),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "域 / 组" } }, [
                    _vm._v(
                      _vm._s(_vm.current.domainName || "未分类") +
                        " / " +
                        _vm._s(_vm.current.groupName || "未分组")
                    ),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "原始位置" } }, [
                    _vm._v(_vm._s(_vm.current.contextText)),
                  ]),
                  _vm.current.recipients
                    ? _c(
                        "el-descriptions-item",
                        { attrs: { label: "邮件收件人" } },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.current.recipients
                                .map((p) => p.name)
                                .join("、")
                            )
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c("el-descriptions-item", { attrs: { label: "时间" } }, [
                    _vm._v(_vm._s(_vm.current.createdAt)),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "状态" } }, [
                    _vm._v(_vm._s(_vm.current.status)),
                  ]),
                  _vm.current.deletedAt
                    ? _c(
                        "el-descriptions-item",
                        { attrs: { label: "删除时间 / 操作人" } },
                        [
                          _vm._v(
                            _vm._s(_vm.current.deletedAt) +
                              " / " +
                              _vm._s(_vm.current.deletedBy)
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm.previewFile
        ? _c("file-preview", {
            attrs: {
              file: _vm.previewFile,
              "can-download": !!_vm.permissions.download,
            },
            on: {
              close: function ($event) {
                _vm.previewFile = null
              },
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("header", [
      _c("h2", [_vm._v("聊天文件")]),
      _c("span", [_vm._v("聊天文件与内部邮件附件 · 独立域 / 组")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }